import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation(); // Get current path

    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to top on path change
    }, [pathname]); // Runs whenever the route changes

    return null;
};

export default ScrollToTop;
